//#region src/locales/ru/tamagotchi/electron/tray.yaml
var data = { "menu": { "labels": { "label": {
	"show": "Показать",
	"adjust_sizes": "Отрегулировать размеры",
	"recommended_size": "Рекомендуется (450x600)",
	"full_height": "Полная высота",
	"half_height": "Половина высоты",
	"full_screen": "Во весь экран",
	"align_to": "Выравнивание по умолчанию",
	"center": "Выравнивание элементов по центру",
	"top_left": "Сверху слева",
	"top_right": "Сверху справа",
	"bottom_left": "Снизу слева",
	"bottom_right": "Снизу справа",
	"settings": "Настройки",
	"about": "О программе",
	"open_inlay": "Открыть Входы",
	"open_widgets": "Открыть виджеты",
	"open_caption": "Открыть субтитры",
	"close_caption": "Закрыть субтитры",
	"caption_overlay": "Наложение субтитров",
	"follow_window": "Перейти в окно",
	"reset_position": "Сбросить положение",
	"devtools": "Инструменты разработчика",
	"troubleshoot_beatsync": "Синхронизация неполадок",
	"quit": "Выход"
} } } };
//#endregion
export { data as default };
